import React, { FC } from "react";
import { AuthorizationResponse } from "paypal-checkout-components";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { NewPayPalButton } from "v3/components/payment/paypal/NewPayPalButton";
import { PAYPAL_DISABLE_FUNDING } from "v3/types/payment";
import { StyledNewPayPalText } from "./index.styled";

interface PayPalPaymentProps {
  onApprove?: (data: AuthorizationResponse) => Promise<void>;
  tokenizeDetails: AuthorizationResponse | null;
}
const { CARD, CREDIT } = PAYPAL_DISABLE_FUNDING;

export const PayPalPayment: FC<PayPalPaymentProps> = ({
  onApprove,
  tokenizeDetails,
}) => {
  return tokenizeDetails ? (
    <>
      <Heading size="xs" level="h3">
        PayPal Details Accepted
      </Heading>
      <StyledNewPayPalText>
        Click the button below to review and place your order.
      </StyledNewPayPalText>
    </>
  ) : (
    <>
      <Heading size="xs" level="h3">
        Pay with PayPal
      </Heading>
      <StyledNewPayPalText>
        You&apos;ll be taken to PayPal to enter payment details, and will return
        here to finalize your order.
      </StyledNewPayPalText>
      <NewPayPalButton
        disable-funding={`${CREDIT},${CARD}`}
        intent="tokenize"
        onApprove={onApprove}
        vault
      />
    </>
  );
};
